import { Link } from '@material-ui/core';
import React, { useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
import { Link as RouterLink } from 'react-router-dom';

import { ReactComponent as OperationHistoryIcon } from '@/assets/icons/operation-history.svg';
import { ReactComponent as OperationInfoIcon } from '@/assets/icons/operation-info.svg';
import { BodyMain, Space } from '@/components';
import { WalletUIState } from '@/model/wallets/types';
import { OptionsSize } from '@/pages/withdrawal/pages/StatusPage/components/SuccessView/types';

export interface HistoryOptionsProps {
  basePath: string;
  size: OptionsSize;
  hideDetails?: boolean;
  transactionId?: string;
}

const HistoryOptions: React.FC<HistoryOptionsProps> = ({ basePath, size, hideDetails, transactionId }) => {
  const flexBasis = useMemo(() => (size === 'xs' ? '50%' : '30%'), [size]);
  const withIcons = useMemo(() => size === 'l' || size === 'xl', [size]);
  return (
    <>
      {!hideDetails && (
        <Space key="operation" direction="vertical" style={{ alignItems: 'center', flex: `0 0 ${flexBasis}` }}>
          {withIcons && <OperationInfoIcon />}
          <BodyMain style={{ textAlign: 'center' }}>
            <FormattedMessage id="withdrawal.pages.result.success.operations.details" />
          </BodyMain>
        </Space>
      )}
      <Link
        variant="body1"
        key="transactions"
        style={{ alignItems: 'center', flex: `0 1 ${flexBasis}` }}
        component={RouterLink}
        to={`/${basePath}/${WalletUIState.TRANSACTIONS}${transactionId ? `#tx-row-${transactionId}` : ''}`}
      >
        <Space direction="vertical" style={{ alignItems: 'center', flex: `0 0 ${flexBasis}` }}>
          {withIcons && <OperationHistoryIcon />}
          <BodyMain style={{ textAlign: 'center', color: '#000000' }}>
            <FormattedMessage id="withdrawal.pages.result.success.operations.history" />
          </BodyMain>
        </Space>
      </Link>
    </>
  );
};

export default HistoryOptions;
